import { apiFetch } from '../../lib/api';

export interface VersionInfo {
  service?: string;
  version?: string;
  commit?: string;
}

export interface AdminStats {
  users?: number;
  devices?: number;
  online_devices?: number;
  events?: number;
  ota_jobs?: number;
  window_hours?: number;
}

export function getVersionInfo(signal?: AbortSignal) {
  return apiFetch<VersionInfo>('/v3/version', { signal });
}

export function getAdminStats(signal?: AbortSignal) {
  return apiFetch<AdminStats>('/v3/admin/stats', { signal });
}

// ---- R18 監控 probe v1 + R17 報表第一批(restful!151;業主代決 2026-07-09)----
// 端點未部署時呼叫端一律降級(catch → 'unavailable'),頁面殼照常。

export interface MonitorComponent {
  component: string;
  status: string; // up | degraded | down | unknown
  checked_at?: number; // µs
  signal_source?: string;
  http_status?: number;
}

export function getMonitoringComponents(signal?: AbortSignal) {
  return apiFetch<{ components?: MonitorComponent[]; cached?: boolean }>('/v3/admin/monitoring/components', { signal });
}

export interface GovernanceActor {
  actor_user_id: string;
  email?: string;
  role?: string;
  actions: number;
}

export interface GovernanceReport {
  window_days?: number;
  generated_at?: number; // µs
  by_action?: Record<string, number>;
  actors?: GovernanceActor[];
}

export function getGovernanceReport(days = 7, signal?: AbortSignal) {
  return apiFetch<GovernanceReport>('/v3/admin/reports/governance', { query: { days }, signal });
}
